(() => {
  if (
    location.pathname !== "/"
    || document.documentElement.dataset.house01TransitionGuardV12
    || !matchMedia("(max-width: 759px)").matches
  ) return;

  document.documentElement.dataset.house01TransitionGuardV12 = "loading";
  const posterUrl = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/23/assets/yizcho-house-01-cat-yawn-nap-mobile-hd-poster-v04.webp?v=1786638448";
  const roomUrl = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/20/assets/yizcho-room-01-mobile-v01.webp?v=1786543473";
  const room2xUrl = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/20/assets/yizcho-room-01-mobile-2x-v01.webp?v=1786543473";
  const imagePromises = new Map();
  let replayingHouseClick = false;

  const nextPaint = () => new Promise((resolve) => requestAnimationFrame(() => {
    requestAnimationFrame(resolve);
  }));

  const decodeWithin = (image, timeout = 520) => Promise.race([
    image.decode().catch(() => {}),
    new Promise((resolve) => setTimeout(resolve, timeout)),
  ]);

  const preloadImage = (src, priority = "auto") => {
    if (imagePromises.has(src)) return imagePromises.get(src);
    const image = new Image();
    image.decoding = "async";
    image.fetchPriority = priority;
    const ready = new Promise((resolve) => {
      image.addEventListener("load", async () => {
        await decodeWithin(image);
        await nextPaint();
        resolve(image.naturalWidth > 0);
      }, { once: true });
      image.addEventListener("error", () => resolve(false), { once: true });
      image.src = src;
    });
    imagePromises.set(src, ready);
    return ready;
  };

  const style = document.createElement("style");
  style.dataset.house01TransitionGuardV12 = "";
  style.textContent = `
    @media (max-width: 759px) {
      body.has-exterior-scene-video .closeup-layer {
        background-color: #12b7d5;
        background-image: url("${posterUrl}");
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  `;
  document.head.append(style);

  const selectedRoomUrl = innerWidth * (devicePixelRatio || 1) >= 1440
    ? room2xUrl
    : roomUrl;
  const posterReady = preloadImage(posterUrl, "high");
  // The 1080-wide room is small enough to warm after window.load and keeps the
  // blue-window tap from competing with the MP4's first request wave.
  setTimeout(() => preloadImage(selectedRoomUrl, "auto"), 700);

  document.addEventListener("click", (event) => {
    const houseControl = event.target.closest?.('[data-id="HOUSE-01"].hotspot');
    if (houseControl && !replayingHouseClick) {
      event.preventDefault();
      event.stopImmediatePropagation();
      houseControl.disabled = true;
      posterReady.then((ready) => {
        const currentHouseControl = document.querySelector('[data-id="HOUSE-01"].hotspot');
        if (currentHouseControl) currentHouseControl.disabled = false;
        if (!ready || !currentHouseControl) return;
        replayingHouseClick = true;
        currentHouseControl.click();
        replayingHouseClick = false;
      });
      return;
    }

  }, true);

  document.documentElement.dataset.house01TransitionGuardV12 = "ready";
})();
